import React from 'react';
import ReactFitText from '@kennethormandy/react-fittext';

export function FitText( props ) {
  return <ReactFitText {...props} />;
}
